import { Grid, Typography } from "@mui/material";
import { required, TextInput } from "react-admin";
import CustomDateInput from "server/components/Fields/CustomDateInput";

const PracticalExternalBuildingsForm = () => {
  return (
    <>
      <Typography
        color={"primary"}
        sx={{ textAlign: "center", fontWeight: "bold", margin: "2rem" }}
      >
        Тип на тема: Практика (външни сгради)
      </Typography>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <CustomDateInput
            source="dateFrom"
            label="От дата"
            validate={required()}
            noTime
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <CustomDateInput
            source="dateTo"
            label="До дата"
            validate={required()}
            noTime
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="certificateNumber"
            label="Номер сертификат"
            validate={required()}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PracticalExternalBuildingsForm;
